import { ButtonProps, ButtonSize, ButtonTheme } from "./index";
import { FC } from "react";

const ContainedButton: FC<ButtonProps> = ({
  children,
  theme = "white",
  size = "md",
  ...props
}) => {
  const buttonSizeClass = getSize(size);
  const buttonThemeClass = getTheme(theme);

  return (
    <button
      {...props}
      className={`font-medium rounded-full group flex items-center justify-center overflow-hidden w-full md:w-max  transition-all duration-300 ease-in-out ${buttonSizeClass}   ${buttonThemeClass}`}
    >
      {children}
    </button>
  );
};

const getTheme = (theme: ButtonTheme): string => {
  if (theme === "primary") {
    return "text-white bg-[#84CC16] hover:bg-[#97CC3C]";
  }

  return "bg-white text-black hover:bg-[#cccccc]";
};
const getSize = (size: ButtonSize): string => {
  if (size === "sm") {
    return "py-2 px-6 text-base md:px-8 md:text-lg md:py-2.5";
  }

  return "py-2 md:py-2.5 px-8 md:text-lg";
};

export default ContainedButton;
